import { PLATFORMS } from '@domain/platform/platform.types';
import { getObjectSelectedFields } from './object-select.utils';
import { ObjectSelected, ObjectSelectedTypes } from './object-selected.types';

export const getObjectSelectedClient = state => state.data.objectSelected.client_selected;
export const getObjectSelectedData = (state): ObjectSelected => state.data.objectSelected;

export const getObjectSelectedPlatform = (state) => {
    const objectSelected = getObjectSelectedData(state);
    return getPlatformFromObjectSelected(objectSelected);
};

export const getPlatformFromObjectSelected = (objectSelected: ObjectSelected) => (
    objectSelected.isAccountSelected
        ? objectSelected.account_selected.content_type_name
        : PLATFORMS.CLIENT
);
export const getObjectSelectedIsLoading = (state): boolean => state
    .data.objectSelected.loadingObjectSelected;

export const getObjectSelected = (state) => {
    const objectSelected = getObjectSelectedData(state);
    const selected = getObjectSelectedFields(objectSelected);

    const type = selected.isAccount ? ObjectSelectedTypes.account : ObjectSelectedTypes.client;

    return {
        ...selected,
        type,
    };
};
